import _classCallCheck from "babel-runtime/helpers/classCallCheck";
import _possibleConstructorReturn from "babel-runtime/helpers/possibleConstructorReturn";
import _inherits from "babel-runtime/helpers/inherits";
import styled from "@emotion/styled";
import { LionTranslate } from "@rosetta/react-lion";
import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import { connect } from "react-redux";
import UAParser from "ua-parser-js";
import { buttonTypes, ModalPrompt } from "@rosetta/react-common-ui";
import { actionCreators } from "./srereducer";

var isOSX = function isOSX() {
  var parser = new UAParser();
  return parser.getOS().name === "Mac OS";
};

var HelpWindow = styled.div({
  "& h1": {
    marginTop: "0px",
    fontSize: "28px",
    marginBottom: "15px",
    fontWeight: "bold"
  },

  "& ul": {
    marginTop: "5px",
    marginBottom: "10px"
  },

  "& li": {
    listStyle: "disc",
    marginBottom: "4px",
    marginLeft: "40px"
  }
});

/*
  Help window that comes up when you click the (?) icon on the calibrate window.
 */

var CalibrateHelp = function (_PureComponent) {
  _inherits(CalibrateHelp, _PureComponent);

  function CalibrateHelp() {
    var _temp, _this, _ret;

    _classCallCheck(this, CalibrateHelp);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _PureComponent.call.apply(_PureComponent, [this].concat(args))), _this), _this.getOsHelpKey = function () {
      // NOTE - we only have translations for mac or pc, you'll get mac instructions if you're on linux or something.
      var key = "mic_calibration_help_popup_system_settings_pc";
      if (isOSX()) {
        key = "mic_calibration_help_popup_system_settings_mac";
      }
      return key;
    }, _this.render = function () {
      var buttons = [{
        labelKey: "mic_calibration_help_popup_ok",
        buttonType: buttonTypes.primary,
        actionFunc: _this.props.closeCalibrateHelp,
        dataQa: "closeCalibrate"
      }];
      return React.createElement(
        ModalPrompt,
        {
          cancelAction: _this.props.closeCalibrateHelp,
          headerTitleKey: "mic_calibration_help_popup_header",
          dataQa: "CalibrateHelp",
          buttons: buttons,
          modalWidth: "auto",
          hideSkipCalibrationLink: true,
          showNavbar: _this.props.showNavbar
        },
        React.createElement(
          HelpWindow,
          null,
          React.createElement(LionTranslate, { blockFormat: true, lionkey: "mic_calibration_help_popup_things_to_try" }),
          React.createElement(LionTranslate, { blockFormat: true, lionkey: _this.getOsHelpKey() }),
          React.createElement(LionTranslate, { blockFormat: true, lionkey: "mic_calibration_help_popup_adjust_settings" })
        )
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  return CalibrateHelp;
}(PureComponent);

CalibrateHelp.propTypes = {
  showNavbar: PropTypes.bool
};
CalibrateHelp.defaultProps = {
  showNavbar: true
};

var CalibrateHelpContainer = connect(null, actionCreators)(CalibrateHelp);

export default CalibrateHelpContainer;